import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import Modal from "@/components/Modal";
import { money } from "@/lib/api";
import { Printer } from "lucide-react";

export default function BarcodeLabel({ product, orgName, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    if (product && ref.current) {
      try {
        JsBarcode(ref.current, product.barcode || "0000", { format: "CODE128", width: 2, height: 60, fontSize: 14, margin: 8 });
      } catch (e) { /* ignore */ }
    }
  }, [product]);

  const print = () => {
    const svg = ref.current?.outerHTML || "";
    const w = window.open("", "_blank", "width=420,height=320");
    if (!w) return;
    w.document.write(
      `<html><head><title>Étiquette ${product.barcode || ""}</title>` +
      `<style>body{font-family:Arial,sans-serif;text-align:center;margin:0;padding:14px}` +
      `.n{font-weight:bold;font-size:14px}.p{font-size:13px;margin:2px 0 8px;color:#2563EB}</style></head>` +
      `<body onload="window.print();setTimeout(function(){window.close()},300)">` +
      `<div class="n">${(orgName || "").replace(/</g, "")}</div>` +
      `<div class="p">${(product.name || "").replace(/</g, "")} — ${money(product.price)}</div>${svg}</body></html>`
    );
    w.document.close();
  };

  return (
    <Modal open={!!product} onClose={onClose} title="Étiquette code-barres" testId="label-modal"
      footer={<><button className="btn-outline" onClick={onClose}>Fermer</button>
        <button className="btn-primary" onClick={print} data-testid="print-label-btn"><Printer className="w-4 h-4" /> Imprimer</button></>}>
      {product && (
        <div className="flex flex-col items-center gap-2 py-5 border border-dashed border-[#CBD5E1] rounded-xl bg-white">
          <div className="font-semibold text-[#16324F]">{product.name}</div>
          <div className="text-sm text-[#2563EB] font-semibold">{money(product.price)}</div>
          <svg ref={ref} data-testid="label-barcode"></svg>
        </div>
      )}
    </Modal>
  );
}
